import axios from '@/config/api.request'

export default {
    // 获取所有文章集合
    getArticles() {
        return axios.request({
            url: '/weixin/offiaccount/articles',
            method: 'get'
        })
    },
    // 根据合集主键查询文章
    getArticlesByAlbumId(albumId) {
        return axios.request({
            url: '/weixin/offiaccount/articles/album',
            method: 'get',
            params: { albumId }
        })
    },
    // 查询全部合集
    getAlbums() {
        return axios.request({
            url: '/weixin/offiaccount/albums',
            method: 'get'
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/blog.js